import { Box, PaginationItem } from "@mui/material";
import OutlinedContainer from "./Container/OutlinedContainer";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";

export default function InlineSelect(props) {
  const {
    name,
    value,
    onChange,
    width,
    options,
    disabledOptions = [],
    required,
    variant,
    shape,
    disabled,
  } = props;
  const { t } = useTranslation();
  function handleChange(newValue) {
    onChange({
      target: {
        name: name,
        value: newValue,
      },
    });
  }

  const formattedDisabledOptions = {};
  disabledOptions.forEach((element) => {
    formattedDisabledOptions[element.value] = element.info ?? "";
  });

  return (
    <OutlinedContainer
      label={t(`FORM.FIELD.${name}`)}
      required={required}
      width={width || "100%"}
    >
      <Box
        paddingTop={0.6}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        {options.map((option, i) => (
          <Tooltip
            title={
              option in formattedDisabledOptions
                ? formattedDisabledOptions[option]
                : ""
            }
            placement="top"
            arrow={true}
            key={i}
          >
            <Box>
              <PaginationItem
                disabled={disabled || option in formattedDisabledOptions}
                variant={variant || "outlined"}
                shape={shape || "rounded"}
                selected={value === option}
                color="primary"
                page={option}
                onClick={() => {
                  handleChange(option);
                }}
              />
            </Box>
          </Tooltip>
        ))}
      </Box>
    </OutlinedContainer>
  );
}
